import { render, staticRenderFns } from "./ShopSwitcher.vue?vue&type=template&id=40fe010c&scoped=true"
import script from "./ShopSwitcher.vue?vue&type=script&lang=js"
export * from "./ShopSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ShopSwitcher.vue?vue&type=style&index=0&id=40fe010c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fe010c",
  null
  
)

export default component.exports